var fundCode;
var fundType;
var name1;
var name2;
var netAssetValueList = null; //基金净值列表

var fundStateTip = {
  0: "开放申/赎",
  1: "开放认购",
  2: "未开放申/赎",
  3: "未开放申/赎",
  4: "未开放申/赎",
  5: "停止申购",
  6: "停止赎回",
  7: "开放申/赎",
  8: "开放申/赎",
  9: "未开放申/赎",
  a: "未开放申/赎",
  b: "预约认购",
  c: "预约申购",
};

$(function () {
  var params = getParams();
  fundCode = params[0];
  // fundType = params[1];

  toApi("qrywalletfundcode.tml", function (json1) {
    localStorage.personalFundCode = json1.personalFundCode;
    if (fundCode === json1.personalFundCode) {
      $("#buyBtn").html("充值");
      $("#investBtn").html("安薪计划");
    }
    toApi(
      "fundproductdatail.tml?fundCode=" + fundCode,
      function (data) {
        fundType = data.info.fundTypeNum;
        if (fundType !== "04") {
          name1 = "累计净值";
          name2 = "单位净值";
        } else {
          $("#ljjz").hide();
          $("#dwjj").html("<i></i>七日年化收益率");
          $("#dayup").html("七日年化");
          $("#netav").html("万份收益");
          name1 = "七日年化收益率";
          name2 = "";
        }
        dataDrawRefresh(30, 0);
        if (data.info.fundTypeNum == "12") {
          data.info.fundType = "FOF";
        }

        $("#prodna").html("<i>" + data.info.prodna + "</i>");
        $("#fundType").html(
          '<i class="red">' + data.info.fundType + "</i></span>"
        );
        $("#fundRiskLevelDesc").html(
          '<i class="red">' + data.info.fundRiskLevelDesc + "</i>"
        );

        var fundName = data.info.prodna;
        var tsrState = data.info.tsrState;
        var serType = data.info.sertype;

        if (fundCode === localStorage.personalFundCode) {
          blueBtnAvailable(
            "buyBtn",
            "isHaveBankCard('wallet/recharge.html','添加银行卡，立即享受收益！','立即添加','暂不')"
          );
          blueBoxBtnAvailable(
            "investBtn",
            "isHaveBankCard('wallet/addanxin.html')"
          );
        } else {
          if (data.info.onShelf === "1") {
            if (
              (tsrState === "0" ||
                tsrState === "1" ||
                tsrState === "6" ||
                tsrState === "7" ||
                tsrState === "8") &&
              data.info.fundSubType != "4"
            ) {
              blueBtnAvailable(
                "buyBtn",
                "fundBuy('" +
                  fundCode +
                  "', '" +
                  data.info.onShelf +
                  "', '" +
                  tsrState +
                  "', '0', '" +
                  data.info.fundSubType +
                  "', '" +
                  data.info.fundTypeNum +
                  "')"
              );
            }
            $("#tsrState").html(
              '<i class="red">' + getFundStateTip(tsrState, "状态错误") + "</i>"
            );

            if (
              serType !== "0" &&
              tsrState !== "a" &&
              tsrState !== "1" &&
              tsrState !== "2" &&
              tsrState !== "3" &&
              tsrState !== "9" &&
              data.info.fundSubType != "4"
            ) {
              //只有当基金定投状态为0时，该只基金才不可定投。
              blueBoxBtnAvailable(
                "investBtn",
                "fundInvestment('" +
                  fundCode +
                  "', '" +
                  fundName +
                  "', 'null', '" +
                  data.info.fundTypeNum +
                  "')"
              );
            }
          } else {
            $("#tsrState").html('<i class="red">停止申购</i>');
          }
        }
        if (fundCode == "000905") {
        } else if (data.info.isCare == "0") {
          $("#gz").html(
            '<a href="javascript:void(0)" class="btn-blue-k a2" onclick="careFund(1)"> + 关注</a>'
          );
        } else {
          $("#gz").html(
            '<a href="javascript:void(0)" class="btn-blue-k a2" onclick="careFund(0)" style="border-color: #9fa5ac;color: #9fa5ac">已关注</a>'
          );
        }

        var fundTypeNum = data.info.fundTypeNum; //  fund type

        if (fundTypeNum === "04") {
          var yield = data.info.yield;
          var yieldColor = null;
          if (!isNull(yield)) {
            yield = Number(yield);
            if (yield > 0) {
              yield = "+" + (yield * 100).toFixed(4) + "%";
              yieldColor = "red";
            } else if (yield < 0) {
              yield = "+" + (yield * 100).toFixed(4) + "%";
              yieldColor = "green";
            }
          } else {
            yield = "-";
          }
          $("#avgreturn_day").html(yield);
          $("#avgreturn_day").addClass(yieldColor);

          $("#nav").html(toThousands(data.info.fundIncome, 4));
        } else {
          var dailyIncreases = data.info.avgreturn_day;
          var dailyColor = null;
          if (!isNull(dailyIncreases)) {
            dailyIncreases = Number(dailyIncreases);
            if (dailyIncreases > 0) {
              dailyIncreases =
                "+" + toThousands(data.info.avgreturn_day, 2) + "%";
              dailyColor = "red";
            } else if (dailyIncreases < 0) {
              dailyIncreases = toThousands(data.info.avgreturn_day, 2) + "%";
              dailyColor = "green";
            } else {
              dailyIncreases = toThousands(data.info.avgreturn_day, 2) + "%";
            }
          } else {
            dailyIncreases = "-";
          }
          $("#avgreturn_day").html(dailyIncreases);
          $("#avgreturn_day").addClass(dailyColor);

          $("#nav").html(toThousands(data.info.nav, 4));
        }

        $("#changeDate").html(data.info.changeDate);

        var nearMonth = handleFundIncrease(data.info.avgreturn_month);
        $("#nearMonth").html(nearMonth.value);
        $("#nearMonth").addClass(nearMonth.color);

        var nearQuarter = handleFundIncrease(data.info.avgreturn_quarter);
        $("#nearQuarter").html(nearQuarter.value);
        $("#nearQuarter").addClass(nearQuarter.color);

        var nearHalfYear = handleFundIncrease(data.info.avgreturn_halfyear);
        $("#nearHalfYear").html(nearHalfYear.value);
        $("#nearHalfYear").addClass(nearHalfYear.color);

        var nearYear = handleFundIncrease(data.info.avgreturn_year);
        $("#nearYear").html(nearYear.value);
        $("#nearYear").addClass(nearYear.color);

        var managerCode = [];
        for (var i = 0; i < data.info.listManager.length; i++) {
          managerCode[i] = data.info.listManager[i].fundManagerNo;
        }

        /* 基金净值列表处理开始  */
        var startDate = obtainDate(currentDate(), 360); //起始时间
        var endDate = getNowDate();
        toApi(
          "netAssetValueList.tml?&fundCode=" +
            fundCode +
            "&startDate=" +
            startDate +
            "&endDate=" +
            endDate,
          function (data2) {
            var infos = data2.infos.reverse();
            var tempLIist = null;
            var html = "";

            if (isNull(infos) || infos.length === 0) {
              $("#noCard").removeClass("none");
              $("#tipMsg").html("暂无净值记录");
              return;
            }

            if (fundType !== "04") {
              //非货币基金
              for (var i = 0; i < infos.length; i++) {
                infos[i].nav = toThousands(infos[i].nav, 4);
                infos[i].total_nav = toThousands(infos[i].total_nav, 4);
                infos[i].nav_date =
                  infos[i].nav_date.substring(0, 4) +
                  "-" +
                  infos[i].nav_date.substring(4, 6) +
                  "-" +
                  infos[i].nav_date.substring(6);
                var result = numberFormatterWithSign(infos[i].avgreturn_day);
                infos[i].avgreturn_day = result.value;
                infos[i].color = result.color;
              }
              $("#tab1").removeClass("none");
              tempLIist = infos.slice(0, 10);
              html = template("netAssetValueTemplate", { list: tempLIist });
            } else {
              for (var j = 0; j < infos.length; j++) {
                infos[j].nav_date =
                  infos[j].nav_date.substring(0, 4) +
                  "-" +
                  infos[j].nav_date.substring(4, 6) +
                  "-" +
                  infos[j].nav_date.substring(6);
                infos[j].milrev = toThousands(infos[j].milrev, 4);
                var yieldResult = numberFormatterWithSign(
                  infos[j].yield * 100,
                  4
                );
                infos[j].yield = yieldResult.value;
                infos[j].color = yieldResult.color;
              }
              $("#tab2").removeClass("none");
              tempLIist = infos.slice(0, 10);
              html = template("netAssetValueTemplate2", { list: tempLIist });
            }
            netAssetValueList = infos;
            var list = fundType !== "04" ? $("#list1") : $("#list2");
            list.html(html);

            var htmlPage = template("tpl_page", {
              index: 1,
              pages: Math.ceil(infos.length / 10),
            });
            $("#page_0").html(htmlPage);
          },
          "fundDetails",
          fundCode
        );
        /* 基金净值列表处理结束 */

        var fundManagerNo = managerCode.toString();
        var div_html = "";
        if (!isNull(fundManagerNo)) {
          toApi(
            "fundmanagerinformation.tml?employeeNo=" + fundManagerNo,
            function (data2) {
              for (var i = 0; i < data2.infos.length; i++) {
                var startTime = "";
                data2.infos[i].fundList.forEach(function (e) {
                  if (e.fundCode == fundCode) {
                    if (isNull(e.startDate) && isNull(e.endDate)) {
                      startTime = "";
                    } else if (!isNull(e.startDate) && isNull(e.endDate)) {
                      startTime = fdate(e.startDate) + " 至今";
                    } else if (isNull(e.startDate) && !isNull(e.endDate)) {
                      startTime = " 至 " + fdate(e.endDate);
                    } else {
                      startTime =
                        fdate(e.startDate) + " 至 " + fdate(e.endDate);
                    }
                  }
                });
                var name = data2.infos[i].name;
                var managerIntro = data2.infos[i].managerIntro;
                var fundList = data2.infos[i].fundList;
                var html = "";

                html +=
                  '<div class="title1 mb_10"><span>' +
                  name +
                  '<span class="gray">' +
                  "    " +
                  startTime +
                  "</span></span></div>"; //<i class=""></i>
                html += '<p class="text1">' + managerIntro + "</p>";
                html += '<div class="line2 mt_25"></div>';
                html += '<div class="title1 mb_10 mt_25">管理的基金</div>';
                html +=
                  '<table class="deal-list" cellspacing="0" cellpadding="0" style="margin-bottom: 20px;">';
                html += "<thead>";
                html += "<tr>";
                html += '<th width="27%">基金名称</th>';
                html += '<th width="32%">任期</th>';
                html += '<th width="16%">操作</th>';
                html += "</tr>";
                html += "</thead>";
                html += '<tbody id="list" >';
                for (var j = 0; j < fundList.length; j++) {
                  if (fundList[j].fundCode != "000905") {
                    html += "<tr>";
                    html +=
                      '<td class="td-l">' + fundList[j].fundName + "</td>";
                    if (
                      isNull(fundList[j].startDate) &&
                      isNull(fundList[j].endDate)
                    ) {
                      html += '<td><span class="gray">暂无</span></td>';
                    } else if (
                      !isNull(fundList[j].startDate) &&
                      isNull(fundList[j].endDate)
                    ) {
                      html +=
                        '<td><span class="gray">' +
                        fdate(fundList[j].startDate) +
                        " 至今</span></td>";
                    } else if (
                      isNull(fundList[j].startDate) &&
                      !isNull(fundList[j].endDate)
                    ) {
                      html +=
                        '<td><span class="gray">  至 ' +
                        fdate(fundList[j].endDate) +
                        "</span></td>";
                    } else {
                      html +=
                        '<td><span class="gray">' +
                        fdate(fundList[j].startDate) +
                        " 至 " +
                        fdate(fundList[j].endDate) +
                        "</span></td>";
                    }
                    html +=
                      '<td><a href="javascript:void(0)" class="btn-text" onclick="gotoDetail(\'' +
                      fundList[j].fundCode +
                      "')\">详情</a></td>";
                    html += "</tr>";
                  }
                }

                html += "</tbody>";
                html += "</table>";
                div_html += html;
              }
              $("#d2").html(div_html);
            },
            "fundmanagerinformation",
            fundCode
          );
        }

        toApi(
          "fundbasic.tml?fundCode=" + fundCode,
          function (data2) {
            // data2.info.faceValue = toThousands(data2.info.faceValue, 2);
            var htmlList = template("tpl_info", { info: data2.info });
            $("#d3").html(htmlList);

            var count = 0;
            for (var i = 0; i < data.info.listFundMony.length; i++) {
              if (data.info.listFundMony[i].business_code === "020") {
                $("#minSub").html(
                  '最低认购金额：<i class="gray">' +
                    data.info.listFundMony[i].min_subs_amount +
                    " 元</i>"
                );
                $("#minSub").removeClass("none");
                count++;
              } else if (data.info.listFundMony[i].business_code === "022") {
                $("#minAmount").html(
                  '最低申购金额：<i class="gray">' +
                    fmoney(data.info.listFundMony[i].min_subs_amount) +
                    " 元</i>"
                );
                $("#minAmount").removeClass("none");
                count++;
              }
            }
            if (count !== 2) {
              $("#registPerson1").removeClass("none");
              $("#registPerson2").addClass("none");
            }
          },
          "fundbasic",
          fundCode
        );
      },
      "fundproductdatail",
      fundCode
    );
  });
  var cut = 1;
  toApi(
    "discountratelist.tml?fundCode=" + fundCode,
    function (data) {
      if (data.infos.length > 0) {
        cut = data.infos[0].discount;
      }

      toApi(
        "qryfundrate.tml?fundCode=" + fundCode,
        function (data) {
          if (data.list.length > 0) {
            var content = '<p class="p1">金额</p>';
            var content2 = '<p class="p1">优惠费率</p>';

            var content3 = '<p class="p1">持有期限</p>';
            var content4 = '<p class="p1">优惠费率</p>';

            data.list.forEach(function (e) {
              if (e.transType == "039") {
                var floatMgmtRateDesc = e.floatMgmtRateDesc;
                var managementRate = e.managementRate;
                if (floatMgmtRateDesc) {
                  $("#managementRate").html(
                    '管理费率(年)：<i class="manageRateDesc">' +
                      floatMgmtRateDesc +
                      "</i>"
                  );
                } else {
                  $("#managementRate").html(
                    '管理费率(年)：<i class="gray">' + managementRate + "%</i>"
                  );
                }

                var managedRate = e.managedRate;
                $("#managedRate").html(
                  '托管费率(年)：<i class="gray">' + managedRate + "%</i>"
                );
                var serviceRate = e.serviceRate;
                $("#serviceRate").html(
                  '销售服务费率(年)：<i class="gray">' + serviceRate + "%</i>"
                );
              }

              if (e.transType == "022") {
                //申购

                e.iteamlist.forEach(function (ee) {
                  if (ee.amountMax == 0) {
                    content +=
                      "<p>" + changeNum(ee.amountMin) + " ≤ 申购金额 </p>";
                  } else {
                    content +=
                      "<p>" +
                      changeNum(ee.amountMin) +
                      " ≤ 申购金额 < " +
                      changeNum(ee.amountMax) +
                      "</p>";
                  }

                  if (ee.fee_type == "0") {
                    content2 +=
                      '<p><i class="gray through">' +
                      parseFloat(ee.rateStandards) +
                      '%</i> <i class="red">' +
                      accMul(ee.rateStandards, cut) +
                      "%</i></p>";
                  } else {
                    content2 += "<p>每笔" + ee.fee_const + "元</p>";
                  }
                });
              } else if (e.transType == "024") {
                //赎回

                e.iteamlist.forEach(function (p1, p2, p3) {
                  if (p2 === p3.length - 1) {
                    content3 +=
                      "<p>" + p1.holddaysMin + "天 ≤ 持有期限 " + "</p>";
                  } else {
                    content3 +=
                      "<p>" +
                      p1.holddaysMin +
                      "天 ≤ 持有期限 " +
                      "< " +
                      p1.holddaysMax +
                      "天" +
                      "</p>";
                  }

                  if (p1.fee_type == "0") {
                    content4 += "<p>" + p1.rateStandards + "%</p>";
                  } else {
                    content4 += "<p>每笔" + p1.fee_const + "元</p>";
                  }
                });
              }
            });

            $("#fl1").html(content);
            $("#fl2").html(content2);

            $("#sh1").html(content3);
            $("#sh2").html(content4);
          }
        },
        "qryfundrate",
        fundCode
      );
    },
    "discountratelist",
    fundCode
  );
});
function gotoDetail(fundCode) {
  window.location.href = phURL + "fund/fundDetail.html?fundCode=" + fundCode;
}
function tabDetail(index) {
  [0, 1, 2, 3].forEach(function (e) {
    if (e == index) {
      $("#t" + e).addClass("active");
      $("#d" + e).removeClass("none");
      $("#d" + e).addClass("record-list-box");
    } else {
      $("#t" + e).removeClass("active");
      $("#d" + e).addClass("none");
      $("#d" + e).removeClass("record-list-box");
    }
  });
}

function careFund(isCare) {
  toApi(
    "attentionorcancelattention.tml?fundCode=" +
      window.location.href.split("=")[1] +
      "&gzflag=" +
      isCare,
    function (data) {
      if (isCare === 1) {
        $("#gz").html(
          '<a href="javascript:void(0)" class="btn-blue-k a2" onclick="careFund(0)" style="border-color: #9fa5ac;color: #9fa5ac">已关注</a>'
        );
      } else {
        $("#gz").html(
          '<a href="javascript:void(0)" class="btn-blue-k a2" onclick="careFund(1)"> + 关注</a>'
        );
      }
    },
    "attentionorcancelattention",
    fundCode
  );
}

function handleFundIncrease(value) {
  var valueColor = null;
  if (!isNull(value)) {
    value = Number(value);
    if (value > 0) {
      value = "+" + toThousands(value, 2) + "%";
      valueColor = "red";
    } else if (value < 0) {
      value = toThousands(value, 2) + "%";
      valueColor = "green";
    } else {
      value = toThousands(value, 2) + "%";
    }
  } else {
    value = "-";
  }
  return {
    value: value,
    color: valueColor,
  };
}

function getUnitvaluetrend(startDate, endDate) {
  var dateList = [];
  var navList = [];
  var ttnavList = [];
  toApi(
    "unitvaluetrend.tml?fundCode=" +
      fundCode +
      "&startDate=" +
      startDate +
      "&endDate=" +
      endDate,
    function (data) {
      if (data.infos.length > 0) {
        for (var t = 0; t < data.infos.length; t++) {
          dateList.push(
            data.infos[t].nav_date.slice(4, 6) +
              "." +
              data.infos[t].nav_date.slice(6, 8)
          );
          if (fundType != "04" && fundType != 04) {
            navList.push(data.infos[t].nav);
            ttnavList.push(data.infos[t].total_nav);
          } else {
            navList.push((data.infos[t].yield * 100).toFixed(4));
          }
        }
        refreshLine(dateList, navList, ttnavList);
      } else {
        refreshLine([0.0], [0.0], [0.0]);
      }
    },
    "unitvaluetrend",
    fundCode
  );
}

function refreshLine(dateList, navList, ttnavList) {
  drawLinePublic(dateList, name1, name2, navList, ttnavList, "jxqzxt", []);
}

var oldDataNum;
function dataDrawRefresh(dateNum, showid) {
  for (var i = 0; i < 4; i++) {
    if (i == showid) {
      $("#" + i).addClass("active");
    } else {
      $("#" + i).removeClass("active");
    }
  }
  if (dateNum == oldDataNum) {
    return;
  }
  oldDataNum = dateNum;
  var nowDate = getNowDate();
  var startDate = addDate(currentDate(), -dateNum);
  getUnitvaluetrend(startDate, nowDate);
}

//乘法函数，用来得到精确的乘法结果
//说明：javascript 的乘法结果会有误差，在两个浮点数相乘的时候会比较明显。这个函数返回较为精确的乘法结果。
//调用：accMul(arg1,arg2)
//返回值：arg1 乘以 arg2 的精确结果
function accMul(arg1, arg2) {
  var m = 0,
    s1 = arg1.toString(),
    s2 = arg2.toString();
  try {
    m += s1.split(".")[1].length;
  } catch (e) {}
  try {
    m += s2.split(".")[1].length;
  } catch (e) {}
  return (
    (Number(s1.replace(".", "")) * Number(s2.replace(".", ""))) /
    Math.pow(10, m)
  );
}

/**
 * 获取基金状态描述
 * @param state
 * @param errMsg
 * @returns {*}
 */
function getFundStateTip(state, errMsg) {
  return fundStateTip[state] || errMsg;
}

/**
 * 翻页
 * @param indexPage: 当前页码
 * @param totalPage: 总页数
 * @param operation: 操作 0-跳转翻页 1-下一页 -1-上一页
 */
function jumpPage(indexPage, totalPage, operation) {
  if (isNull(netAssetValueList)) {
    return;
  }

  var displayPage =
    operation !== 0 ? indexPage + operation : $("#pageNo" + indexPage).html();
  if (displayPage > totalPage || displayPage <= 0) {
    return;
  }

  var showList = netAssetValueList.slice(
    (displayPage - 1) * 10,
    displayPage * 10
  );
  var html =
    fundType !== "04"
      ? template("netAssetValueTemplate", { list: showList })
      : template("netAssetValueTemplate2", { list: showList });
  var list = fundType !== "04" ? $("#list1") : $("#list2");
  list.html(html);

  var htmlPage = template("tpl_page", { index: displayPage, pages: totalPage });
  $("#page_0").html(htmlPage);
}

function tian(startP, endP) {
  for (var i = 0, len = tempLIist.length; i < len; i++) {
    html += "<tr>";
    html += '<td class="td-l">' + tempLIist[i].nav_date + "</td>";
    html += '<td class="td-l">' + tempLIist[i].total_nav + "</td>";
    html += '<td class="td-l">' + tempLIist[i].nav + "</td>";
    html +=
      '<td class="td-l ' +
      tempLIist[i].color +
      '">' +
      tempLIist[i].avgreturn_day +
      "</td>";
    html += "</tr>";
  }
}

function gotoFundBuy() {
  // {
  //     fundCode:outLineFundCode,
  //     productInfoId: loadValue("summaryID",false),
  //     transCode: outLineUrl == "addfundinvestment" ? "039" : "020", // 认申购020，定投039，转换036
  //     ptfCode: 0
  // }
  if (!loadValue("unScrollbottom", false)) {
    alert("请先完成全文阅读");
    return;
  }
  removeValue("unScrollbottom", false);
  $("#pupFundOutline").hide();
  var outLineFundCode = loadValue("outLineFundCode", false);
  var outLineUrl = loadValue("outLineUrl", false);
  var outLineFundName = loadValue("outLineFundName", false);
  removeValue("outLineFundCode", false);
  removeValue("outLineUrl", false);
  var S092019params = { fundSummaryVos: fundSummaryArr, source: "fundDetail" };
  var nextPage = function () {
    removeValue("summaryID", false);
    console.log(S092019params);
    if (outLineUrl == "addfundinvestment") {
      window.location.href =
        phURL +
        "fund/addfundinvestment.html?fundName=" +
        outLineFundName +
        "&fundCode=" +
        outLineFundCode;
    } else {
      window.location.href =
        window.phURL + "fund/fundBuy.html?fundCode=" + outLineFundCode;
    }
  };
  toApi_toAc("S092019", S092019params, nextPage, "", "", nextPage);
}

function readNext() {
  console.log(222222, itemArr);
  //循环对象，找到下一个未读的展示，如果找不到，则代表全部已读，执行之后的业务逻辑
  noReadArr = itemArr.filter(function (val) {
    return val.hasRead == false;
  });
  console.log(33333, noReadArr);
  if (noReadArr.length == 0) {
    $("#pupFundOutline").hide();
    var outLineFundCode = loadValue("outLineFundCode", false);
    var outLineUrl = loadValue("outLineUrl", false);
    var outLineFundName = loadValue("outLineFundName", false);
    removeValue("outLineFundCode", false);
    removeValue("outLineUrl", false);
    var S092019params = {
      fundSummaryVos: fundSummaryArr,
      source: "fundDetail",
    };
    var nextPage = function () {
      removeValue("summaryID", false);
      console.log(S092019params);
      if (outLineUrl == "addfundinvestment") {
        window.location.href =
          phURL +
          "fund/addfundinvestment.html?fundName=" +
          outLineFundName +
          "&fundCode=" +
          outLineFundCode;
      } else {
        window.location.href =
          window.phURL + "fund/fundBuy.html?fundCode=" + outLineFundCode;
      }
    };
    toApi_toAc("S092019", S092019params, nextPage, "", "", nextPage);
  } else {
    // nowIndex = noReadArr[0].eq;
    console.log(nowIndex);

    if (itemArr[nowIndex].hasRead) {
      if (parseInt(nowIndex) + 1 == itemArr.length) {
        nowIndex = 0;
      } else {
        nowIndex++;
      }
      $(".outLine_box").eq(nowIndex).show().siblings().hide();
      $(".titleItem")
        .eq(nowIndex)
        .addClass("active")
        .siblings()
        .removeClass("active");
      return;
    }
    itemArr[nowIndex].hasRead = true;

    hasReadNum = itemArr.filter(function (val) {
      return val.hasRead == true;
    }).length;
    if (parseInt(hasReadNum) < itemArr.length) {
      $(".nextBtn2").text(
        "我已阅读并知悉(" + hasReadNum + "/" + itemArr.length + ")"
      );
    } else {
      readNext();
    }

    if (parseInt(nowIndex) + 1 == itemArr.length) {
      nowIndex = 0;
    } else {
      nowIndex++;
    }
    $(".outLine_box").eq(nowIndex).show().siblings().hide();
    $(".titleItem")
      .eq(nowIndex)
      .addClass("active")
      .siblings()
      .removeClass("active");
  }
}
